<script>
  import * as cepService from '../../../../services/cepService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {set, get} from '@utils/storage'

  import {required, requiredIf, email} from 'vuelidate/lib/validators'

  export default {
    mixins: [helpers],
    props: ['valido'],
    data () {
      return {
        abrirDatepickerDtNascimento: false,
        anos_enem: [],
        readonlyEndereco: true,
        readonlyBairro: false,
        form: {
          nome: '',
          email: '',
          telefone: '',
          cpf: '',
          rg: '',
          dt_nascimento: '',
          sexo: 'M',
          fl_treineiro: false,
          fl_necessidade_especial: true,
          fl_auxilio_prova: false,
          fl_receber_contato: true,
          cep: '',
          endereco: '',
          numero: '',
          complemento: '',
          cidade: '',
          bairro: '',
          estado: '',
          enem: '',
          ref_local_prova: '',
          local_prova: '',
          ano_enem: ''
        }
      }
    },
    validations: {
      form: {
        nome: {required},
        email: {required, email},
        telefone: {required},
        cpf: {required},
        rg: {required},
        dt_nascimento: {required},
        cep: {required},
        endereco: {required},
        numero: {required},
        cidade: {required},
        bairro: {required},
        estado: {required},
        enem: {
          required: requiredIf(function () {
            return this.form.fl_enem
          })
        },
        ano_enem: {
          required: requiredIf(function () {
            return this.form.fl_enem
          })
        }
      }
    },
    computed: {
      dt_nascimento_formatada () {
        return this.form.dt_nascimento ? this.dateFormat(this.form.dt_nascimento, 'br') : ''
      }
    },
    watch: {
      '$v.form.$invalid': {
        handler: function (value) {
          this.$emit('update:valido', !value)
          this.setDadosPessoais()
          setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
        deep: true
      },
      'form.cep': function (value) {
        if (value && value.length > 8) {
          cepService.get(value).then(item => {
            this.form.endereco = item.logradouro
            this.readonlyEndereco = this.form.endereco.length > 1
            this.form.cidade = item.localidade
            this.form.bairro = item.bairro
            this.readonlyBairro = this.form.bairro.length > 1
            this.form.estado = item.uf
          }).catch(e => {
            this.form.endereco = ''
            this.form.cidade = ''
            this.form.bairro = ''
            this.form.estado = ''
          })
        }
      }
    },
    async mounted () {
      const data = await get('form')
      this.form = {...this.form, ...data}
      this.form.fl_necessidade_especial = data.fl_necessidade_especial
      this.anos_enem = this.form.anos_enem
      bus.$emit('hide-loader')
    },
    methods: {
      async setDadosPessoais () {
        if (this.form.fl_necessidade_especial === false) {
          this.form.fl_auxilio_prova = false
        }
        let form = await get('form')
        this.form.ref_local_prova = form.ref_local_prova
        this.form.local_prova = form.local_prova
        form = {...form, ...this.form}
        set('form', form)

        if (this.form.cep.length === 8) {
          this.$v.form.cep.$touch()
        }
      },
      formatarDataNascimento () {
        this.$v.form.dt_nascimento_formatada.$touch()
        this.form.dt_nascimento = this.dateFormat(this.form.dt_nascimento_formatada, 'en')
      }
    }
  }

</script>
<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-form>
                <v-card>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <h2 class="title">Dados Pessoais</h2>
                        </v-flex>
                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field color="amber darken-3"
                                          v-model="form.nome"
                                          label="Nome Completo"
                                          @input="$v.form.nome.$touch()"
                                          @blur="$v.form.nome.$touch(); setDadosPessoais()"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.email"
                                    label="E-mail"
                                    :error-messages="validationMessageField($v.form.email, ['required', 'validEmail'])"
                                    @input="$v.form.email.$touch()"
                                    @blur="$v.form.email.$touch(); setDadosPessoais()"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.telefone"
                                    label="Telefone"
                                    v-mask="'(##) #####-####'"
                                    :error-messages="validationMessageField($v.form.telefone)"
                                    @input="$v.form.telefone.$touch()"
                                    @blur="$v.form.telefone.$touch(); setDadosPessoais()"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.cpf"
                                    label="CPF"
                                    v-mask="'###.###.###-##'"
                                    :error-messages="validationMessageField($v.form.cpf, ['required'])"
                                    @input="$v.form.cpf.$touch()"
                                    @blur="$v.form.cpf.$touch(); setDadosPessoais()"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.rg"
                                    label="RG"
                                    :error-messages="validationMessageField($v.form.rg)"
                                    @input="$v.form.rg.$touch()"
                                    @blur="$v.form.rg.$touch(); setDadosPessoais()"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-menu ref="abrirDatepickerDtNascimento"
                                    :close-on-content-click="false"
                                    v-model="abrirDatepickerDtNascimento"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px">
                                <v-text-field slot="activator"
                                              :value="dt_nascimento_formatada"
                                              :error-messages="validationMessageField($v.form.dt_nascimento)"
                                              v-mask="'##/##/####'"
                                              label="Data de Nascimento"
                                              append-icon="event"
                                              clearable
                                              readonly></v-text-field>
                                <v-date-picker v-model="form.dt_nascimento"
                                               no-title
                                               ref="picker"
                                               :max="new Date().toISOString().substr(0, 10)"
                                               @input="abrirDatepickerDtNascimento = false"
                                               locale="pt-br"></v-date-picker>
                            </v-menu>
                        </v-flex>

                        <v-flex class="pr-3" xs12>
                            <div class="vestibular-label">Sexo?</div>
                            <v-radio-group
                                    v-model="form.sexo" row>
                                <v-radio label="Masculino" color="primary" value="M" @blur="setDadosPessoais()"
                                         @change="setDadosPessoais()"></v-radio>
                                <v-radio label="Feminino" color="primary" value="F" @blur="setDadosPessoais()"
                                         @change="setDadosPessoais()"></v-radio>
                            </v-radio-group>
                        </v-flex>

                        <v-flex v-if="form.fl_enem" class="pr-3" xs12 sm6>
                            <v-select
                                    v-model="form.ano_enem"
                                    :items="anos_enem"
                                    label="Ano de inscrição no ENEM"
                                    @input="$v.form.ano_enem.$touch(); setDadosPessoais()"
                                    @blur="$v.form.ano_enem.$touch(); setDadosPessoais()"
                                    :error-messages="validationMessageField($v.form.ano_enem, ['required'])"
                                    clearable
                            ></v-select>
                        </v-flex>

                        <v-flex v-if="form.fl_enem" class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.enem"
                                    label="Inscrição ENEM"
                                    @input="$v.form.enem.$touch()"
                                    @blur="$v.form.enem.$touch(); setDadosPessoais()"
                                    :error-messages="validationMessageField($v.form.enem, ['required'])"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6 row>
                            <div>Treineiro?</div>
                            <v-switch color="primary"
                                      :label="`${form.fl_treineiro ? 'Sim' : 'Não'}`"
                                      v-model="form.fl_treineiro"
                                      @blur="setDadosPessoais()"
                                      @change="setDadosPessoais()"
                            >
                            </v-switch>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6 row>
                            <div>Possui necessidade especial?</div>
                            <v-switch color="primary"
                                      :label="`${form.fl_necessidade_especial ? 'Sim' : 'Não'}`"
                                      v-model="form.fl_necessidade_especial"
                                      @blur="setDadosPessoais()"
                                      @change="setDadosPessoais()">
                            </v-switch>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6 row>
                            <div>Necessita de auxílio para realizar a prova?</div>
                            <v-switch color="primary"
                                      :disabled="!form.fl_necessidade_especial"
                                      :label="`${form.fl_auxilio_prova ? 'Sim' : 'Não'}`"
                                      v-model="form.fl_auxilio_prova"
                                      @blur="setDadosPessoais()"
                                      @change="setDadosPessoais()">
                            </v-switch>
                        </v-flex>

                        <v-flex xs12>
                            <v-divider></v-divider>
                        </v-flex>
                        <v-flex xs12>
                            <h2 class="title pt-2">Endereço</h2>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.cep"
                                    label="CEP"
                                    v-mask="'#####-###'"
                                    :error-messages="validationMessageField($v.form.cep)"
                                    @input="$v.form.cep.$touch()"
                                    @blur="$v.form.cep.$touch(); setDadosPessoais()"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.endereco"
                                    label="Endereço"
                                    :error-messages="validationMessageField($v.form.endereco)"
                                    @input="$v.form.endereco.$touch()"
                                    @blur="$v.form.endereco.$touch(); setDadosPessoais()"
                                    :readonly="readonlyEndereco ? true : false"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.numero"
                                    label="Número"
                                    :error-messages="validationMessageField($v.form.numero)"
                                    @input="$v.form.numero.$touch()"
                                    @blur="$v.form.numero.$touch(); setDadosPessoais()"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.complemento"
                                    label="Complemento"
                                    @blur="setDadosPessoais()"
                                    :counter="40"
                                    maxLength="40"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.cidade"
                                    label="Cidade"
                                    :error-messages="validationMessageField($v.form.cidade)"
                                    @input="$v.form.cidade.$touch()"
                                    @blur="$v.form.cidade.$touch(); setDadosPessoais()"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.bairro"
                                    label="Bairro"
                                    :error-messages="validationMessageField($v.form.bairro)"
                                    @input="$v.form.bairro.$touch()"
                                    @blur="$v.form.bairro.$touch(); setDadosPessoais()"
                                    :readonly="readonlyBairro ? true : false"
                            ></v-text-field>
                        </v-flex>

                        <v-flex class="pr-3" xs12 sm6>
                            <v-text-field
                                    v-model="form.estado"
                                    label="Estado"
                                    :error-messages="validationMessageField($v.form.estado)"
                                    @input="$v.form.estado.$touch()"
                                    @blur="$v.form.estado.$touch(); setDadosPessoais()"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                    </v-layout>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>




// WEBPACK FOOTER //
// DadosPessoais.vue?667ed748